import { ReactNode } from 'react';
import styles from './confirmation-card.module.css';

interface ConfirmationCardProps {
  title?: string;
  action?: ReactNode;
  data?: [];
  items?: Array<{ label: string; value: string }>;
}

const ConfirmationCard: React.FC<ConfirmationCardProps> = ({
  title,
  items,
  action,
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.cardManageSection}>
        {title && <div className={styles.cardType}>{title}</div>}
        <div className={styles.cardWrap}>
          <div className={styles.cardStatus}>{action}</div>
        </div>
      </div>
      <div className={styles.cardInfoSection}>
        {items?.map((item) => (
          <div key={item.label} className={styles.cardInfoType}>
            <span>{item.label}</span>
            <span className={item.value.length > 10 ? styles.textOverflow : ''}>
              {item.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConfirmationCard;
